import React, {
	useState,
	useEffect,
	useCallback,
	useRef,
	Ref,
} from 'react';

import './browser-iframe.scoped.css';

import { APP_CONFIG } from '../../config';

import CQLogo from '../../assets/img/cq-logo.svg';
import ChitkaraLogo from '../../assets/img/chitkara.png';

const Logo = (APP_CONFIG.isChitkara) ? ChitkaraLogo : CQLogo;

interface BrowserIframeProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
	browserRef?: Ref<HTMLIFrameElement>;
	notifyURLChange?: (url: string | undefined) => void,
}
export const BrowserIframe: React.FC<BrowserIframeProps> = (props) => {
	const {
		src,
		srcDoc,
		title = 'preview',
		sandbox,
		browserRef,
		onLoad,
		notifyURLChange,
		...rest
	} = props;

	const internalRef = useRef<HTMLIFrameElement | null>(null);
	const [loading, setLoading] = useState(true);
	const [urlToShow, setUrlToShow] = useState<string | undefined>();

	useEffect(() => {
		if (notifyURLChange) {
			notifyURLChange(urlToShow);
		}
	}, [urlToShow, notifyURLChange]);

	useEffect(() => {
		setLoading(true);
		if (src) {
			setUrlToShow(src);
			return () => { };
		}
		if (srcDoc) {
			const blob = new Blob([srcDoc], { type: 'text/html' });
			const url = URL.createObjectURL(blob);
			setUrlToShow(url);
			return () => {
				setTimeout(() => {
					URL.revokeObjectURL(url);
				}, 2_000);
			};
		}
		return () => {

		};
	}, [src, srcDoc]);

	useEffect(() => {
		if (!browserRef) return;
		if (typeof browserRef === 'function') {
			browserRef(internalRef.current);
		} else {
			try {
				(browserRef as React.MutableRefObject<HTMLIFrameElement | null>)
					.current = internalRef.current;
				// eslint-disable-next-line no-empty
			} catch { }
		}
	}, [browserRef]);

	const handleFrameLoad = useCallback(
		(e: React.SyntheticEvent<HTMLIFrameElement, Event>) => {
			setLoading(false);
			onLoad?.(e);
		},
		[onLoad],
	);

	return (
		<div className="browser-iframe-container">
			<iframe
				// eslint-disable-next-line react/jsx-props-no-spreading
				{...rest}
				ref={internalRef}
				title={title}
				sandbox={sandbox}
				className="browser-iframe"
				src={urlToShow}
				onLoad={handleFrameLoad}
			/>
			{loading && (
				<div className="browser-iframe-loading-container">
					<img className="loader-logo blink" src={Logo} alt="loader logo" />
					<p style={{ color: '#333333b5', fontSize: 16, textAlign: 'center' }}>Loading...</p>
				</div>
			)}
		</div>
	);
};

export default BrowserIframe;
